export default function About() {
  const milestones = [
    { year: '1998', event: 'The journey began in 1998 with projects like Airfire, Sonic Inc. and Traveller — charting in Belgium, the Netherlands and the UK, with video clips on VIVA and MTV.' },
    { year: '2003', event: 'Founded Venom-Recordings, AceAge-Records and publishing company AceAge-Musikverlag. Launched Ace\'s Delight — "Sublime" album, a hit in Japan and the USA.' },
    { year: '2004', event: 'Added dance chart productions and film soundtrack work to his portfolio, with projects involving Captain Jack featuring Roberto Blanco, Franca Morgano of Magic Affair, and Hollywood composer Wolfram de Marco.' },
    { year: '2006', event: 'Partnered with DJ Talla 2XLC — "No Signs", "I Know" or "Shine" were released with huge success. Talla 2XLC later awarded the badge of honour by Frankfurt city for his musical archievements.' },
    { year: '2012', event: 'Began developing newcomer DJs in the EDM scene, discovered and produced LE SHUUK, supporting his path to international recognition, and contributed to projects linked to the Eurovision Song Contest.' },
    { year: '2013', event: 'Established "Taste of Summer" by Sonic Inc. as the main goal anthem for Royal Antwerp FC, turning the track into a signature stadium track for one of Belgium\'s most historic football clubs.' },
    { year: '2014', event: 'Produced the official Big City Beats - World Club Dome - anthems for 4 consecutive years, including its sub-branch World Club Dome Korea in 2017.' },
    { year: '2018', event: 'Contributed to LE SHUUK\'s international breakthrough with "Victorum", a Smash The House release reworking Andreas Schmidt\'s original Sonic Inc. track "Taste of Summer" and reaching #1 in the Beatport Big Room Top 100 Charts.' },
    { year: '2019', event: 'Teamed up with newcomer DJ KASPAR, moving into Future Bass and Peak Time Techno. Directly signed to Krafttek for their debut single.' },
    { year: '2021', event: 'Kaspar & A*S*Y*S — "Injection" hits No. 1 on Beatport Techno Top 100 and Top 20 on Spotify main charts. Both artists rank in the global Top 40 best-selling Techno artists.' },
  ];

  return (
    <section id="about" className="relative py-32 px-6 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20music%20studio%20synthesizers%20and%20mixing%20console%20close%20up%20with%20warm%20golden%20amber%20yellow%20lighting%2C%20vintage%20analog%20hardware%20knobs%20and%20faders%20glowing%20in%20warm%20candlelight%20tones%2C%20modular%20synth%20rack%20bathed%20in%20golden%20hour%20light%2C%20deep%20dark%20background%20with%20rich%20warm%20yellow%20and%20amber%20highlights%2C%20no%20people%2C%20cinematic%20wide%20shot%2C%20ultra%20detailed%20studio%20gear%2C%20moody%20warm%20atmosphere%2C%20professional%20photography&width=1920&height=1080&seq=about-bg-synth-warm-3&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0a0a0a]/70" />
        <div className="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-black to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Section label */}
        <div className="flex items-center gap-3 mb-10">
          <span className="w-10 h-px bg-white/30" />
          <span className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase">About</span>
        </div>

        {/* Main two-column layout */}
        <div className="flex flex-col lg:flex-row gap-16 items-start">

          {/* Left col — title + bio + photo + quote (60%) */}
          <div className="w-full lg:w-[60%] lg:flex-shrink-0 flex flex-col gap-10">

            {/* Title + bio */}
            <div>
              <h2
                className="text-white font-bold mb-6 leading-tight"
                style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em' }}
              >
                The Man Behind<br />the Music
              </h2>
              <p className="text-white/60 text-base leading-relaxed mb-4">
                Andreas Schmidt is a German music entrepreneur with more than three decades of experience across artist development, music production, label work, and music publishing. As the founder of AceAge-Music, he has built an independent music company bringing together two record labels, the publishing agency AceAge-Musikverlag, and a wide range of professional music services under one roof.
              </p>
              <p className="text-white/60 text-base leading-relaxed">
                Andreas works closely with established and rising artists, creating and producing the music that helps them define their sound, shape their identity, and grow their audience. His productions have contributed to releases reaching top positions in major national charts, Beatport&apos;s genre-specific Top 100 charts, leading Spotify editorial playlists, and airplay on international commercial radio stations. Regardless of genre, his focus remains the same: bringing each artist&apos;s vision to life in the strongest possible way.
              </p>
            </div>

            {/* Photo */}
            <div className="relative">
              <img
                src="https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/7e36fa33-27f3-4946-84e5-f7f46df40078_Ace-Studio-Pic.png?v=ba62456ef16a5aef33f9f1664139282b"
                alt="Andreas Schmidt"
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute -bottom-3 -right-3 w-full h-full border border-white/10 rounded-lg -z-10" />
            </div>

            {/* Quote card */}
            <div className="border border-white/10 rounded-lg p-8 bg-white/[0.03]">
              <i className="ri-double-quotes-l text-3xl text-white/20 block mb-4" />
              <p className="text-white/70 text-lg leading-relaxed italic" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                "Creating a track is a bit like raising a child — it takes patience, devotion, the right guidance and love to grow into something truly great."
              </p>
              <p className="text-white/40 text-sm mt-5 font-medium tracking-widest uppercase">— Andreas Schmidt</p>
            </div>

          </div>

          {/* Right col — Journey timeline (40%), aligned to headline top */}
          <div className="flex-1 min-w-0">
            <h3 className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase mb-6">Journey</h3>
            <div className="space-y-1">
              {milestones.map((m, i) => (
                <div key={i} className="flex gap-5 group">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-2 h-2 rounded-full bg-white/40 group-hover:bg-white transition-colors mt-1" />
                    {i < milestones.length - 1 && <div className="w-px flex-1 bg-white/10 mt-2 mb-1" />}
                  </div>
                  <div className="pb-4">
                    <span className="text-white/30 text-xs font-bold tracking-widest uppercase">{m.year}</span>
                    <p className="text-white/70 text-sm mt-1 leading-relaxed">{m.event}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
